import { ToursProvider } from './Tours/context/tours.context';
import Tours from './Tours';

const ToursScreen = () => (
    <div style={{ margin: '24px 4px' }}>
        <ToursProvider>
            <Tours />
        </ToursProvider>
    </div>
);

export default ToursScreen;
